<form [formGroup]="noteForm" novalidate>
  <div class="py-3">
    <div class="row mx-0 align-items-center">
      <label class="me-2 mb-0">Unit #@if (isRequirednoteForm('unitRented')) {
        <span class='required'
        >*</span>
      }</label>
      <ejs-multiselect id='multiselect-checkbox' style = "width:200px" #checkbox [dataSource]="unitsList" [fields]="fieldsvalues" [mode]="mode"  [showDropDownIcon]='true' [allowFiltering]="false" formControlName="LinkedUnitId"></ejs-multiselect>
    </div>
    <div class="row mt-3">
      <div class="col-12">
        <div class="d-inline-flex">
          <label class="mt-2">Internal Note@if (isRequirednoteForm('Notes')) {
            <span class='required'
            >*</span>
          }</label>
          <label class="pure-material-checkbox ms-4 mt-2">
            <input type="checkbox" class="custom-control-input" class="form-control"
              formControlName="PriorityNotes" (change)="Addprioirtynote($event)">
              <span class="font_weight_500">Priority Note</span>
            </label>
            <div class="ms-3 d-inline-flex label_responsive">
              <span style="width: 155px;" class="span_margin">Keep Active Until</span>
              <ejs-datepicker [readonly]="!noteForm.value.PriorityNotes" class="form-control p-0 ipad-date h-auto"
                name="date" format='MM/dd/yyyy' floatLabelType='Always' formControlName="keepActiveDate"
                [min]='today' [allowEdit]="false">
              </ejs-datepicker>
            </div>
          </div>
          <textarea rows="5" class="form-control mt-2" formControlName="Notes"
            [style.color]="noteForm.value.PriorityNotes ? 'red': 'black'"
          [ngClass]="{'highlight-textarea': noteForm.value.PriorityNotes === true}" appRestrictHtmltagchars></textarea>
        </div>
      </div>
      <div class="row mt-3">
        <div class="col-12">
          <label>Customer Note@if (isRequirednoteForm('CustomerNotes')) {
            <span class='required'>*</span>
          }</label>
          <textarea rows="5" class="form-control" formControlName="CustomerNotes" appRestrictHtmltagchars></textarea>
        </div>
      </div>

    </div>
    <div class="m text-end">
      <button type="button" class="btn btn-outline-primary me-3" data-dismiss="modal" (click)="cancelNotes()">
        Cancel
      </button>
      <button type="submit" class="btn btn-primary" [disabled]="disableNote()"
      (click)="saveNotesAuthentication($event)">Save</button>
    </div>
  </form>

  <app-fingerprintpopup (cancelFingerPrint)="cancelFingerPrint($event)" (emitSuccess)="emitFingerPrintSuccess($event)">
  </app-fingerprintpopup>
